<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="客户信息：" prop="nameOrPho">
            <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" size="small" />
          </el-form-item>
          <el-form-item label="客户身份：" prop="levelId">
            <el-select v-model="query.levelId" placeholder="请选择折扣组" clearable size="small">
              <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="折扣组：">
            <el-select v-model="query.profitRatioId" placeholder="请选择折扣组" clearable size="small">
              <el-option :label="item.title" :value="item.id" v-for="item in discountList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用友编码：" prop="code">
            <el-input v-model="query.code" placeholder="请输入用友编码" size="small" />
          </el-form-item>
          <el-form-item label="账号类型：">
            <el-select v-model="query.mainId" placeholder="请选择账号类型" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="主账号" :value="0"></el-option>
              <el-option label="子账号" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="认证类型：">
            <el-select v-model="query.certificates_type" placeholder="请选择认证类型" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="企业认证" :value="1"></el-option>
              <el-option label="个人认证" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="通商云ID：" prop="yuntognshangId">
            <el-input v-model="query.yuntognshangId" placeholder="请输入通商云ID" size="small" />
          </el-form-item> -->
          <el-form-item label="是否登录APP：">
            <el-select v-model="query.isLoginApp" placeholder="请选择是否登录APP" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属区域：">
            <el-cascader v-model="query.addrid" :props="cascaderProps" collapse-tags :options="addressList" :show-all-levels="false" clearable placeholder="请选择所属区域" size="small"></el-cascader>
          </el-form-item>
          <el-form-item label="业务员：">
            <el-select v-model="query.ywName" filterable placeholder="请选择业务员" clearable size="small" filterable :filter-method="businessFilter" @blur="getBusinessList()">
              <el-option :label="`${item.name}（${item.levelName}）${item.pho}`" :value="item.name" v-for="item in businessList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="技术老师：">
            <el-select v-model="query.technicianName" filterable placeholder="请选择技术老师" clearable size="small">
              <el-option :label="`${item.realName}（${item.levelName}）`" :value="item.realName" v-for="item in technicianList"
                :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="所属城市公司：">
            <el-select v-model="query.cityCompanyId" filterable placeholder="请选择所属城市公司" clearable size="small" filterable :filter-method="cityCompanyFilter" @blur="getCityList()">
              <el-option :label="item.name" :value="item.id" v-for="item in cityCompanyList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="移入公海时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-upload style="display: inline-block;margin:0 5px" :action="uploadImgUrl" :show-file-list="false" :http-request="uploadFile" :file-list="fileList" v-hasPermi="['client:publicClient:import']">
            <el-button size="mini" type="primary" plain>导入</el-button>
          </el-upload>
          <el-button type="primary" size="mini" @click="handleDownTemplate" plain>下载模板</el-button>
          <img src="../../../assets/Vector.png" class="vector" @click="handleChangeFields">
          <!-- <el-button type="primary" size="mini" @click="handleUpdate(row,0)">批量分配</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <el-table-column type="selection" width="50" />
        <el-table-column :width="item.width" v-for="(item,index) in dynamicHeaders" :key="index" :prop="item.prop" :label="item.label" :fixed="index<2" :sortable="item.isSortable" :align="item.align">
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.customer.id)" v-if="item.prop === 'customer'">
              <el-link type="primary">{{row.customer.name}}({{row.customerLevel.name}})</el-link><br />
              <el-link type="primary">{{row.customer.pho}}</el-link>
            </div>
            <span v-else-if="item.prop === 'sysProfitRatio.title'">{{row.sysProfitRatio.title}}</span>
            <span v-else-if="item.prop === 'customer.code'">{{row.customer.code}}</span>
            <block v-else-if="item.prop === 'customerCertificates'">
              <div @click="handleShow(row)" v-if="row.customerCertificates">
                <el-link type="primary">认证类型：{{row.customerCertificates.certificatesType==1?'企业认证':'个人认证'}}</el-link><br />
                <el-link type="primary" v-if="row.customerCertificates.certificatesType==1">企业名称：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
                <el-link type="primary" v-if="row.customerCertificates.certificatesType==2">姓名：{{row.customerCertificates?row.customerCertificates.companyName:''}}</el-link>
              </div>
            </block>
            <span v-else-if="item.prop === 'tsyId'">{{row.customerUserPO.bizUserId}}</span>
            <block v-else-if="item.prop === 'addr'">
              <span v-if="row.addr.length">{{row.addr[0].regionName}}{{row.addr[1].regionName}}{{row.addr.length==3?row.addr[2].regionName:''}}</span>
            </block>
            <block v-else-if="item.prop === 'line'">
              <span v-if="row.line">{{row.line.name}}({{row.lineLevel.name}})</span>
            </block>
            <span v-else-if="item.prop === 'cityCompany'">{{row.cityCompany?row.cityCompany.cityCompanyName:''}}</span>
            <block v-else-if="item.prop === 'userWallet'">
              <div class="flexs">
                <div style="display: flex;flex-direction: column;">
                  <span>余额：{{row.userWallet?row.userWallet.balance:0}}</span>
                  <span>零售价：{{row.userWallet?row.userWallet.xiaoduMoney:0}} </span>
                </div>
                <div style="display: flex;flex-direction: column;margin-left: 5px;">
                  <span>赠送：{{row.userWallet?row.userWallet.tuition :0}}</span>
                  <span> 积分账户：{{row.userWallet?row.userWallet.integral:0}}</span>
                </div>
              </div>
            </block>
            <span v-else-if="item.prop === 'customer.openSeaReason'">{{row.customer.openSeaReason}}</span>
            <span v-else-if="item.prop === 'customer.openSeaTime'">{{dayjs(row.customer.openSeaTime).format("YYYY-MM-DD HH:mm:ss")}}</span>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,1)" v-hasPermi="['client:publicClient:allocation']">分配</el-button>
            <el-button type="text" @click="handleUpdates(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 分配 -->
    <technician-add ref="technicianAdd" @created="doQueryList({})" />
    <change-fields-vue ref="fieldsPopup" :allTemplate="allTemplate" :cList="dynamicHeaders" @updated="doColumnList" />
    <!-- 打标签 -->
    <!-- <label-add ref="labelAdd"  @created="doQueryList({})" :labelList="labelList"/> -->
    <!-- 企业认证 -->
    <!-- <client-show ref="clientShow" @created="doQueryList({})"></client-show> -->
  </div>
</template>

<script>
import technicianAdd from './add'
import cityCompanyApi from '@/api/sys/cityCompany'
// import clientShow from './show'
// import labelAdd from './addLabel'
import clientListApi from '@/api/client/clientList'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import customerLevelApi from '@/api/sys/customerLevel'
import sysProfitRatioApi from '@/api/sys/sysProfitRatio'
import sysAddrApi from '@/api/sys/sysAddr'
import clientLabelApi from '@/api/client/label'
import Pagination from '@/components/Pagination'
import userApi from '@/api/sys/user'
import changeFieldsVue from '@/views/common/changeFields.vue'
export default {
  components: {
    Pagination,
    technicianAdd,
    changeFieldsVue
  },
  data() {
    return {
      // level 6:研修班 7:体验班 8:普通用户
      list: [],
      total: 0,
      popType: null,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        customerType: 3
      },
      selectItems: [],
      activeName: '1',
      standingList: [],
      discountList: [],
      addressList: [],
      technicianList: [],
      businessList: [],
      cityCompanyList: [],
      dateTime: null,
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        // multiple: true
      },
      allTemplate: [{
        label: '客户信息',
        prop: 'customer',
        width: '160px',
        align: 'center'
      }, {
        label: '折扣组',
        prop: 'sysProfitRatio.title',
        width: '120px',
        align: 'center'
      }, {
        label: '用友编码',
        prop: 'customer.code',
        width: '130px',
        align: 'center'
      }, {
        label: '子账号数量',
        prop: 'subCount',
        width: '100px',
        align: 'center'
      }, {
        label: '认证信息',
        prop: 'customerCertificates',
        width: '160px'
      },
      {
        label: '通商云ID',
        prop: 'tsyId',
        align: 'center'
      }, {
        label: '所属区域',
        prop: 'addr',
        width: '160px',
        align: 'center'
      }, {
        label: '发展业务线',
        prop: 'line',
        width: '160px',
        align: 'center'
      }, {
        label: '所属城市公司',
        prop: 'cityCompany',
        width: '110px',
        align: 'center'
      }, {
        label: '账户剩余明细',
        prop: 'userWallet',
        width: '240px'
      }, {
        label: '移入公海原因',
        prop: 'customer.openSeaReason',
        width: '130px',
        align: 'center'
      }, {
        label: '移入公海时间',
        prop: 'customer.openSeaTime',
        isSortable: true,
        width: '160px',
        align: 'center'
      }, {
        label: '操作人',
        prop: 'operated_by',
        align: 'center'
      }
      ],
      dynamicHeaders: [],
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    })
    this.getStandingList()
    this.getDiscountList()
    this.getAddressList()
    // this.getTechnicianList()
    this.getBusinessList()
    this.getCityList()
    this.getFieled()
  },
  methods: {
    handleChangeFields() {
      this.$refs.fieldsPopup.open();
    },
    doColumnList(checkedList) {
      if (checkedList && !checkedList.length) return
      let allList = JSON.parse(JSON.stringify(this.allTemplate))
      let newL = allList.filter(item => checkedList.indexOf(item.prop) > -1)
      this.dynamicHeaders = newL;
      localStorage.setItem('publicClientTableColumn', JSON.stringify(newL))
    },
    getFieled() {
      if (localStorage.getItem('publicClientTableColumn')) {
        let tColumn = JSON.parse(localStorage.getItem('publicClientTableColumn'))
        this.dynamicHeaders = tColumn
      } else {
        this.dynamicHeaders = this.allTemplate
      }
    },
    getCityList(e) {
      let obj = { pageNo: 1, pageSize: 100, state: 1 }
      // if(e){
      obj.cityCompanyName = e
      // }
      cityCompanyApi.fetchList(obj).then(({
        data
      }) => {
        this.cityCompanyList = data.list
        // console.log('客户身份:111111111111 ',data);
      })
    },
    businessFilter(e) {
      // console.log('e',e)
      this.getBusinessList(e)
    },
    cityCompanyFilter(e) {
      this.getCityList(e)
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        customerType: 3
      }
      this.dateTime = []
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.standingList = data
        // console.log('客户身份: ',data);
      })
    },
    // 获取折扣组列表
    getDiscountList() {
      sysProfitRatioApi.fetchList().then(({
        data
      }) => {
        this.discountList = data
        // console.log('折扣组列表: ',data);
      })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.isOpenSea = 1
      let query = { ...this.query }
      if (this.dateTime && this.dateTime.length) {
        query.startTimeOpenSea = this.dateTime[0]
        query.endTimeOpenSea = this.dateTime[1]
      }
      // console.log('localStorage.getItem('userInfo'): ',localStorage.getItem('userInfo'));
      if (this.query.addrid) {
        query.addrid = this.query.addrid[this.query.addrid.length - 1]
      }
      // this.query.displayPosition=this.activeName
      this.listLoading = true
      return clientListApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleUpdates(row) {
      this.$router.push("/log/log?type=2&id=" + row.customer.id);
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({
        data
      }) => {
        this.addressList = this.formatCascaderData(data)
        // console.log('地区列表: ',data);
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },

    // 获取业务员列表
    getBusinessList(e) {
      let obj = { customerTypes: 2, isGetAllParent: true, pageNo: 1, pageSize: 100 }
      // if(e){
      obj.name = e
      // }
      clientListApi.getListPageForMini(obj).then(({
        data
      }) => {
        this.businessList = data.list
        
      })
    },
    //查看信息
    handleShowDetail(id) {
      this.$emit('handleShow', id, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row, type) {
      if (!type && this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择客户')
        return
      }
      this.$refs.technicianAdd.handleCreate({ row: type ? row : this.selectItems, type })
    },
    handleDownTemplate() {
      clientListApi.importExcelCustomertemplate()
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      clientListApi.importExcelCustomer(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>
<style>
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>
